import Vue from "vue";
import Router from "vue-router";
import VueGtm from '@gtm-support/vue2-gtm';

import store from "../store";
import Calculator from "@/pages/Calculator.vue";
import aboutEasi from "@/pages/About_EASI.vue";
import Contanct from "@/pages/Contact.vue";
import Login from "@/pages/Login.vue";
import Registration from "@/pages/Registration.vue";
import ResetPassword from "@/pages/ResetPassword.vue";
import ForgotPassword from "@/pages/ForgotPassword.vue";
import EmailConfirm from "@/pages/EmailConfirm.vue";
import Patients from "@/pages/Patients.vue";
import AddEvaluation from "@/pages/AddEvaluation.vue";
import EditEvaluation from "@/pages/EditEvaluation.vue";
import Plots from "@/pages/Plots.vue";
import iosRedirect from "@/pages/iosRedirect.vue";
import androidRedirect from "@/pages/androidRedirect.vue";
import landingPage from "@/pages/landingPage.vue";
import Photos from "@/pages/Photos.vue";
import {
  isUserAuth,
  getRefreshTokenExpTime,
  clearStorage
} from "@/utils/localStorageUtils";
import moment from "moment";


Vue.use(VueGtm, {
  id: 'GTM-595NSWL', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  nonce: '2726c7f26c', // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

Vue.use(Router);

// Use hash mode for cordova build
const router = new Router({
  mode: process.env.BASE_URL === "" ? "hash" : "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      beforeEnter: (to, from, next) => {
        isUserAuth() ? next({ name: "kalkulator" }) : next();
      },
      name: "landing-page",
      component: landingPage
    },
    {
      path: "/kalkulator",
      name: "kalkulator",
      component: Calculator
    },
    {
      path: "/prihlaseni",
      name: "prihlaseni",
      component: Login,
      meta: { authorized: false }
    },
    {
      path: "/registrace",
      name: "regitrace",
      component: Registration,
      meta: { authorized: false }
    },
    {
      path: "/co-je-easi",
      name: "co-je-easi",
      component: aboutEasi
    },
    {
      path: "/kontakt",
      name: "kontakt",
      component: Contanct
    },
    {
      path: "/obnova-hesla",
      name: "obnova-hesla",
      component: ResetPassword,
      meta: { authorized: false }
    },
    {
      path: "/zapomenute-heslo",
      name: "zapomenute-heslo",
      component: ForgotPassword,
      meta: { authorized: false }
    },
    {
      path: "/overeni-emailu",
      name: "overeni-emailu",
      component: EmailConfirm,
      meta: { authorized: false }
    },
    {
      path: "/pacienti/:userId?/:formId?",
      name: "pacienti",
      component: Patients,
      meta: { authorized: true }
    },
    {
      path: "/pacient/:id/pridat-vyhonoceni",
      name: "pridat-vyhodnoceni",
      component: AddEvaluation,
      meta: { authorized: true }
    },
    {
      path: "/pacient/:id/grafy",
      name: "grafy",
      component: Plots,
      meta: { authorized: true }
    },
    {
      path: "/pacient/:id/fotodokumentace",
      name: "fotodokumentace",
      component: Photos,
      meta: { authorized: true }
    },
    {
      path: "/pacient/:id/:formId/upravit-vyhodnoceni",
      name: "upravit-vyhodnoceni",
      component: EditEvaluation,
      meta: { authorized: true }
    },
    {
      path: "/ios",
      name: "ios",
      component: iosRedirect
    },
    {
      path: "/android",
      name: "android",
      component: androidRedirect
    },
    {
      path: "/:catchAll(.*)",
      name: "NotFound",
      beforeEnter: (to, from, next) => {
        isUserAuth()
          ? next({ name: "kalkulator" })
          : next({ name: "landing-page" });
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  const isRefreshTokenExpired = moment(getRefreshTokenExpTime())
    .add(-1, "minutes")
    .isBefore(moment());
  const isAuthenticated = isUserAuth() && !isRefreshTokenExpired;

  // 1) Check whether route has define meta
  if (to.meta.authorized !== undefined) {
    // 2) Check whether user have to be authorized on current route
    if (to.meta.authorized) {
      // 3) Check whether user authenticated
      if (isAuthenticated) {
        next();
      } else {
        // In case user isn't authenticated clear storages and reroute to login page
        clearStorage();
        store.commit("setAuthenticated", false);
        next({ name: "prihlaseni" });
      }
    } else {
      return isAuthenticated ? next({ name: "kalkulator" }) : next();
    }
  }

  next({});
});

export default router;
